import { isDevelopment } from 'src/utils';
import { AppLovinPixel, Clarity, GoogleAnalyticsComponent, PinterestPixel, TikTokPixel, TwitterPixel } from '@features/Analytics';
import { DebugUi } from '@features/Analytics/components/DebugUi';
import { useShouldInit } from '@features/Analytics/hooks';
import { BingPixel } from '@features/Analytics/components/BingPixel';
import { GoogleTagManager } from '@features/Analytics/components/GoogleAnalytics';
import { SnapchatPixel } from '@features/Analytics/components/SnapchatPixel';
import { GTM_ID } from '@features/Analytics/constants';
import { useExternalId } from '@features/Analytics/hooks/useExernalId';
import FbPixel from '../FacebookPixel';
export const AnalyticsInject = () => {
  const {
    shouldPixelInit,
    shouldPTInit,
    shouldTwitterInit,
    shouldTikTokInit,
    shouldGoogleAnalyticsV2Init,
    shouldGoogleAnalyticsInit,
    shouldAppLovinInit,
    shouldClarityInit,
    shouldClarityV2Init,
    shouldBingInit,
    shouldSnapchatInit
  } = useShouldInit();
  const externalId = useExternalId();
  return <>
      {shouldPixelInit && externalId && <FbPixel externalId={externalId} />}
      {shouldGoogleAnalyticsV2Init && GTM_ID && <GoogleTagManager />}
      {shouldGoogleAnalyticsInit && externalId && <GoogleAnalyticsComponent externalId={externalId} shouldSecondGaInit={shouldGoogleAnalyticsV2Init} />}
      {shouldAppLovinInit && <AppLovinPixel />}
      {shouldPTInit && <PinterestPixel />}
      {shouldBingInit && <BingPixel />}
      {shouldTwitterInit && <TwitterPixel />}
      {shouldTikTokInit && <TikTokPixel />}
      {shouldSnapchatInit && <SnapchatPixel />}
      {(shouldClarityInit || shouldClarityV2Init) && <Clarity initSecondClarity={shouldClarityV2Init} />}
      {isDevelopment && <DebugUi />}
    </>;
};